export default __webpack_public_path__ + "static/media/tea.a5886af3.svg";